// --------------------------------------------------------------------------
// #TBC - Pictogram and block chart generator
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var Handlebars = require('handlebars');

module.exports = function () {

	function init(detailData, chartType, isEditable) {
		/*
   * App that takes a JSON dataset, converts it to flat format
   * and displays it as a table, with intergers converted to star svgs
   * using a handlebars template
   * it also offers controls for addign and removing stars
   * R.Bultitue 2015
   */
		//globals
		//Placeholder for HTML / jQuery Object we want to return
		var maxShapes = 15;

		function findLastShape(context) {
			var allCells = $(context).parents('tr').find('.color-block');
			var index = -1;

			for (var i = 0; i < allCells.length; i++) {
				if ($(allCells[i]).children().length) {
					index = i;
				} else {
					break;
				}
			}

			return {
				allCells: allCells,
				index: index,
				numShapes: index + 1
			};
		}
		function getShape(type) {
			var typePrefixed = '#' + type + '-shape-template';
			var source = $(typePrefixed).html();
			var template = Handlebars.compile(source);
			var shapeTemplate = template();
			var $shapeTemplate = $(shapeTemplate);
			return $shapeTemplate;
		}

		Handlebars.registerHelper('formatCircle', function (colour) {
			var $circle = getShape(chartType);
			$circle.find('circle').css('fill', colour);
			$circle.find('path').css('fill', colour);

			return new Handlebars.SafeString($circle.prop('outerHTML'));
		});

		Handlebars.registerHelper('formatSquare', function (colour) {
			var $square = getShape(chartType);
			$square.find('rect').css('fill', colour);

			return new Handlebars.SafeString($square.prop('outerHTML'));
		});

		Handlebars.registerHelper('ifLessThan', function (v1, v2, options) {
			if (v1 < v2) {
				return options.fn(this);
			}

			return options.inverse(this);
		});

		/*
  * Repeat given markup with given times
  * provides @index for the repeated iteraction
  */
		Handlebars.registerHelper('repeat', function (times, opts) {
			var out = '';
			var i;
			var data = {};

			if (times) {
				for (i = 0; i < times; i += 1) {
					data.index = i;
					out += opts.fn(this, {
						data: data
					});
				}
			} else {

				out = opts.inverse(this);
			}

			return out;
		});

		Handlebars.registerHelper('json', function (data) {
			return JSON.stringify(data);
		});

		function manageShapes(shape, type) {
			$('[data-binding="chart-container"]').off();

			$('[data-binding="chart-container"]').on('click', '.increase', function () {
				var lastShapeObj = findLastShape(this);
				var allCells = lastShapeObj.allCells;
				var index = lastShapeObj.index;
				var numShapes = lastShapeObj.numShapes;

				var colour = allCells.parents('tr').data('colour');
				if (type === 'pictogram') {
					shape.find('circle').css('fill', colour);
					shape.find('path').css('fill', colour);
				} else if (type === 'block') {
					shape.find('rect').css('fill', colour);
				}

				if (numShapes < maxShapes) {
					$(allCells[index + 1]).append(shape.prop('outerHTML'));
				} else {
					console.log('Too many shapes');
				}
			});

			$('[data-binding="chart-container"]').on('click', '.decrease', function () {
				var lastShapeObj = findLastShape(this);
				var allCells = lastShapeObj.allCells;
				var index = lastShapeObj.index;
				var numShapes = lastShapeObj.numShapes;

				if (numShapes !== 0) {
					$(allCells[index]).children().remove();
				} else {
					console.log('Too few shapes');
				}
			});
		}

		function buildPictoBlock(data, type, editable) {
			//Done with pure JS in this function
			var editSuffix = '-edit';
			var selector = type + '-template';
			if (editable === true) {
				selector += editSuffix;
			}

			data.maxShapes = maxShapes;

			var stringHtml = document.getElementById(selector).innerHTML;
			var template = Handlebars.compile(stringHtml);
			var html = template(data);
			manageShapes(getShape(type), type);
			return html;
		}

		var pictoBlock = buildPictoBlock(detailData, chartType, isEditable);
		return pictoBlock;
	}
	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-pictogram-block.js
// module id = 237
// module chunks = 0